import AdvancedView from "./advancedView";

export default AdvancedView;
